export default __webpack_public_path__ + "static/media/single_web-md@1x.ace66cae.webp";